import PropTypes from 'prop-types';
import I18n from 'I18n';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import ConsentCheckbox from './ConsentCheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
const ConsentToCommunicate = ({
  message,
  companyName,
  consentToCommunicate = false,
  onChange
}) => {
  const cleanMessage = message && formatHtml(message) || I18n.text('conversations-visitor-message-history.email-capture.consentToCommunicate', {
    accountName: companyName
  });
  return /*#__PURE__*/_jsx(ConsentCheckbox, {
    message: cleanMessage,
    isChecked: consentToCommunicate,
    onChange: onChange
  });
};
ConsentToCommunicate.displayName = 'ConsentToCommunicate';
ConsentToCommunicate.propTypes = {
  companyName: PropTypes.string,
  consentToCommunicate: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
export default ConsentToCommunicate;